/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'ai-mate.chat-error-banner.description': 'Je chatgeschiedenis wordt maximaal 30 dagen opgeslagen.',
  'ai-mate.chat-error-banner.title': 'Start een nieuwe chat',
  'ai-mate.chat-error.description': 'Probeer <btn>de chat opnieuw te laden</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Je hebt het maximumaantal aanvragen bereikt. Probeer het later opnieuw.',
  'ai-mate.chat-error.rate-limited-title': 'Te veel aanvragen',
  'ai-mate.chat-error.rovo-inactive-description':
    'Het lijkt erop dat Rovo niet is ingeschakeld op je site. <link>Rovo instellen</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo is inactief',
  'ai-mate.chat-error.title': 'We weten niet zeker wat er misging',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Rovo-chat',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Vraag AI hierover',
  'highlight-actions.rovo-chat-explain-option.text': 'Uitleggen',
  'highlight-actions.rovo-chat-explain-prompt': 'Leg {selectedText} uit',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Aanbevelingen voor de chat',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Chat openen',
  'highlight-actions.rovo-chat-summarize-option.text': 'Samenvatten',
  'highlight-actions.rovo-chat-summarize-prompt': 'Vat deze {selectedText} samen',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'horizontal-scroll-container.scroll-left': 'Scrol naar links',
  'horizontal-scroll-container.scroll-right': 'Scrol naar rechts',
};
